<template>
    <div class="container-fluid">
        <!--<div class="row" style="background-color: #fff; border-radius: 5px; padding: 20px;">
            <div class="col-md-12 mt-5">
                <h5 class="text-end">বিসমিল্লাহির রহমানির রাহিম</h5>
            </div>
            <hr class="hr-cls">
            <div class="col-md-12 col-sm-6 d-flex justify-content-between">
                <router-link class="btn btn-success" to="/admin/wasiyyah-preview">{{$t('Wasiyyah Preview')}}
                    <font-awesome-icon icon="chevron-right" style="margin-left: 5px; font-size: 12px; color: #fff"/>
                </router-link>

                <h3 class="text-end fw-bold">ওয়াসিয়াহ (ইচ্ছানামা)</h3>
            </div>
            <hr class="hr-cls1 mt-3">
            <div class="col-8 text-center para">
                <p>আসসালামু আলাইকুম ওয়া রাহমাতুল্লা ইন্নালহামদালিল্লাহি রাব্বিল আ'লামীন ওয়াসসালাতু ওয়াসসালামু আলা
                    রাসুলিল্লাহ (সাল্লাল্লাহু আলাইহিসসালাম)।</p>
            </div>

            <draggable
                    v-model="getDataWasiyyah"
                    group="wasiyyah"
                    @start="drag = true"
                    @end="updateOrder"
                    tag="div"
                    class="row draggable-container"
            >

                <template #item="{ element }">
                    <div
                            class="col-md-8 mt-5 draggable-item"
                            :key="element.requestKey"
                            style="margin-left: 160px; border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;"
                    >
                        <div class="mt-2 wasiyyah-card" :style="{ opacity: element.visible === 'Y' ? 1.0 : 0.2 }">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="text-center mt-3">
                                        <template v-if="editModeKey === element.requestKey">
                                            <input
                                                    v-model="editFormData.title"
                                                    placeholder="Enter Title"
                                                    required
                                                    class="form-control"
                                            />
                                        </template>
                                        <template v-else>
                                            {{ element.title }}
                                        </template>
                                    </h4>
                                    <hr/>
                                </div>
                                <div class="col-md-12">
                                    <p class="text-justify p-3">
                                        <template v-if="editModeKey === element.requestKey">
                                            <b-form-textarea
                                                    class="mt-3"
                                                    id="textarea"
                                                    v-model="editFormData.content"
                                                    placeholder="Enter wasiyyah content"
                                                    rows="12"
                                                    max-rows="6"
                                                    required
                                            ></b-form-textarea>
                                        </template>
                                        <template v-else>
                                            {{ element.content }}
                                        </template>
                                    </p>
                                </div>
                                <div class="col-md-12 justify-content-between d-flex">
                                    <template v-if="editModeKey === element.requestKey">
                                        <button @click="submitEdit" class="btn btn-info mb-2 ms-0 text-white">
                                            <font-awesome-icon icon="pen-to-square" class="text-white"/>
                                            Save
                                        </button>
                                        <button @click="cancelEdit" class="btn btn-danger mb-2 me-0">
                                            <font-awesome-icon icon="times"/>
                                            Cancel
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="edit">
                                            <button
                                                    @click="enterEditMode(element)"
                                                    class="btn btn-success mb-2 ms-0"
                                                    v-if="element.visible === 'Y'"
                                            >
                                                <font-awesome-icon icon="pen-to-square"/>
                                                Edit
                                            </button>
                                        </div>
                                        <div class="view"
                                             :style="{ textAlign: element.visible === 'Y' ? 'right' : 'center' }">
                                            <button @click="contentVisible(element)" class="btn btn-success mb-2 me-0">
                                                <font-awesome-icon
                                                        :icon="element.visible === 'Y' ? 'eye' : 'eye-slash'"/>
                                                View
                                            </button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </draggable>


            &lt;!&ndash; existing code &ndash;&gt;
            &lt;!&ndash;   <div
                       class="col-md-8 mt-5"
                       v-for="item in getDataWasiyyah"
                       :key="item.requestKey"
                       style="margin-left: 160px; border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;">
                   <div class="mt-2 wasiyyah-card" :style="{ opacity: item.visible === 'Y' ? 1.0 : 0.2 }">
                       <div class="row">
                           <div class="col-md-12">
                               {{ editFormData.title }}
                               <h4 class="text-center mt-3">
                                   <template v-if="editModeKey === item.requestKey">
                                       <input
                                               v-model="editFormData.title"
                                               placeholder="Enter Title"
                                               required class="form-control"/>
                                   </template>
                                   <template v-else>
                                       {{ item.title }}
                                   </template>
                               </h4>
                               <hr>
                           </div>
                           <div class="col-md-12">
                               <p class="text-justify p-3">
                                   <template v-if="editModeKey === item.requestKey">
                                       <b-form-textarea
                                               class="mt-3"
                                               id="textarea"
                                               v-model="editFormData.content"
                                               placeholder="Enter wasiyyah content"
                                               rows="12"
                                               max-rows="6"
                                               required
                                       ></b-form-textarea>
                                       &lt;!&ndash;                                    <textarea v-model="editFormData.content" cols="40" rows="" class="form-control"></textarea>&ndash;&gt;
                                   </template>
                                   <template v-else>
                                       {{ item.content }}
                                   </template>
                               </p>
                           </div>
                           <div class="col-md-12 justify-content-between d-flex">
                               <template v-if="editModeKey === item.requestKey">
                                   <button @click="submitEdit" class="btn btn-info mb-2 ms-0 text-white">
                                       <font-awesome-icon icon="pen-to-square" class="text-white"/>
                                       Save
                                   </button>
                                   <button @click="cancelEdit" class="btn btn-danger mb-2 me-0">
                                       <font-awesome-icon icon="times"/>
                                       Cancel
                                   </button>
                               </template>
                               <template v-else>
                                   <div class="edit">
                                       <button @click="enterEditMode(item)" class="btn btn-success mb-2 ms-0"
                                               v-if="item.visible == 'Y'">
                                           <font-awesome-icon icon="pen-to-square"/>
                                           Edit
                                       </button>
                                   </div>
                                   <div class="view" :style="{ textAlign: item.visible === 'Y' ? 'right' : 'center' }">
                                       <button @click="contentVisible(item)" href="" class="btn btn-success mb-2 me-0">
                                           <font-awesome-icon :icon="item.visible === 'Y' ? 'eye' : 'eye-slash'"/>
                                           &lt;!&ndash;                                    <font-awesome-icon icon="eye"/>&ndash;&gt;
                                           &lt;!&ndash;                                    <font-awesome-icon icon="eye-slash" />&ndash;&gt;
                                           View
                                       </button>
                                   </div>

                               </template>
                           </div>
                       </div>
                   </div>
               </div>&ndash;&gt;
            &lt;!&ndash; existing code&ndash;&gt;

            <div class="col-md-12 text-center mt-5">
                <a href="javascript:void(0);" @click="toggleDivVisibility" class="btn btn-success btn-lg" value="Y">CREATE
                    WASIYYAH</a>
            </div>
            <div class="col-md-8 mt-5" v-if="isVisible"
                 style="margin-left: 160px; border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;">
                <div class=" mt-2">
                    <div class="row">
                        <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
                            <div class="col-md-12">
                                <b-form-group :label="wasiyyahEntryData.contentTitle" label-for="wasiyyah_title">
                                    <b-form-input
                                            v-model="wasiyyahEntryData.title"
                                            placeholder="Enter Title*"
                                            id="title"
                                            required
                                    >
                                    </b-form-input>
                                </b-form-group>
                                <hr>
                            </div>
                            <div class="col-md-12 mb-4">
                                <input
                                        v-show="false"
                                        v-model="wasiyyahEntryData.orderSeq"
                                        type="text"
                                />
                                <b-form-textarea
                                        :class="[textColor,'mt-3']"
                                        id="textarea"
                                        v-model="wasiyyahEntryData.content"
                                        placeholder="Enter wasiyyah content*"
                                        rows="6"
                                        max-rows="6"
                                        required
                                ></b-form-textarea>
                            </div>
                            <div class="col-md-12 justify-content-between d-flex">
                                <button type="submit" :disabled="letterCount < 100" class="btn btn-success mb-2 ms-0">
                                    <font-awesome-icon icon="pen-to-square"/>
                                    New Entry
                                </button>
                                <a href="" class="btn btn-success mb-2 me-0">
                                    <font-awesome-icon icon="eye"/>
                                    View</a>
                            </div>
                        </b-form>

                    </div>
                </div>
            </div>
        </div>-->

        <div class="row" style="background-color: #fff; border-radius: 5px; padding: 20px;">
            <div class="col-md-12 mt-5">
                <h5 class="text-end">বিসমিল্লাহির রহমানির রাহিম</h5>
            </div>

            <hr class="hr-cls">

            <div class="col-md-12 col-sm-12 d-flex flex-column flex-md-row justify-content-between">
                <router-link class="btn btn-success mb-2 mb-md-0" to="/admin/wasiyyah-preview">
                    {{$t('Wasiyyah Preview')}}
                    <font-awesome-icon icon="chevron-right" style="margin-left: 5px; font-size: 12px; color: #fff" />
                </router-link>

                <h3 class="text-end fw-bold">ওয়াসিয়াহ (ইচ্ছানামা)</h3>
            </div>

            <hr class="hr-cls1 mt-3">

            <div class="col-md-8 col-sm-12 text-center para mx-auto">
                <p>
                    আসসালামু আলাইকুম ওয়া রাহমাতুল্লা ইন্নালহামদালিল্লাহি রাব্বিল আ'লামীন ওয়াসসালাতু ওয়াসসালামু আলা
                    রাসুলিল্লাহ (সাল্লাল্লাহু আলাইহিসসালাম)।
                </p>
            </div>

            <draggable
                    v-model="getDataWasiyyah"
                    group="wasiyyah"
                    @start="drag = true"
                    @end="updateOrder"
                    tag="div"
                    class="row draggable-container"
            >
                <template #item="{ element }">
                    <div
                            class="col-md-8 col-sm-12 mt-5 draggable-item mx-auto"
                            :key="element.requestKey"
                            style="border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;"
                    >
                        <div class="mt-2 wasiyyah-card" :style="{ opacity: element.visible === 'Y' ? 1.0 : 0.2 }">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="text-center mt-3">
                                        <template v-if="editModeKey === element.requestKey">
                                            <input
                                                    v-model="editFormData.title"
                                                    placeholder="Enter Title"
                                                    required
                                                    class="form-control"
                                            />
                                        </template>
                                        <template v-else>
                                            {{ element.title }}
                                        </template>
                                    </h4>
                                    <hr />
                                </div>
                                <div class="col-md-12">
                                    <p class="text-justify p-3">
                                        <template v-if="editModeKey === element.requestKey">
                                            <b-form-textarea
                                                    class="mt-3"
                                                    id="textarea"
                                                    v-model="editFormData.content"
                                                    placeholder="Enter wasiyyah content"
                                                    rows="12"
                                                    max-rows="6"
                                                    required
                                            ></b-form-textarea>
                                        </template>
                                        <template v-else>
                                            {{ element.content }}
                                        </template>
                                    </p>
                                </div>
                                <div class="col-md-12 d-flex  flex-md-row justify-content-between">
                                    <template v-if="editModeKey === element.requestKey">
                                        <button @click="submitEdit" class="btn btn-info mb-2 ms-0 text-white">
                                            <font-awesome-icon icon="pen-to-square" class="text-white" />
                                            {{$t('Save')}}
                                        </button>
                                        <button @click="cancelEdit" class="btn btn-danger mb-2 me-0">
                                            <font-awesome-icon icon="times" />
                                            {{$t('Cancel')}}
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="edit">
                                            <button
                                                    @click="enterEditMode(element)"
                                                    class="btn btn-success mb-2 ms-0"
                                                    v-if="element.visible === 'Y'"
                                            >
                                                <font-awesome-icon icon="pen-to-square" />
                                                {{$t('Edit')}}
                                            </button>
                                        </div>
                                        <div class="view" :style="{ textAlign: element.visible === 'Y' ? 'right' : 'center' }">
                                            <button @click="contentVisible(element)" class="btn btn-success mb-2 me-0">
                                                <font-awesome-icon :icon="element.visible === 'Y' ? 'eye' : 'eye-slash'" />
                                                {{$t('View')}}
                                            </button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </draggable>

            <div class="col-md-12 text-center mt-5">
                <a href="javascript:void(0);" @click="toggleDivVisibility" class="btn btn-success btn-lg" value="Y">
                    CREATE WASIYYAH
                </a>
            </div>

            <div
                    class="col-md-8 col-sm-12 mt-5 mx-auto"
                    v-if="isVisible"
                    style="border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;"
            >
                <div class="mt-2">
                    <div class="row">
                        <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
                            <div class="col-md-12">
                                <b-form-group :label="wasiyyahEntryData.contentTitle" label-for="wasiyyah_title">
                                    <b-form-input
                                            v-model="wasiyyahEntryData.title"
                                            placeholder="Enter Title*"
                                            id="title"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                                <hr />
                            </div>

                            <div class="col-md-12 mb-4">
                                <input
                                        v-show="false"
                                        v-model="wasiyyahEntryData.orderSeq"
                                        type="text"
                                />
                                <b-form-textarea
                                        :class="[textColor, 'mt-3']"
                                        id="textarea"
                                        v-model="wasiyyahEntryData.content"
                                        placeholder="Enter wasiyyah content*"
                                        rows="6"
                                        max-rows="6"
                                        required
                                ></b-form-textarea>
                            </div>

                            <div class="col-md-12 d-flex flex-column flex-md-row justify-content-between">
                                <button type="submit" :disabled="letterCount < 100" class="btn btn-success mb-2 ms-0">
                                    <font-awesome-icon icon="pen-to-square" />
                                    New Entry
                                </button>
                                <a href="javascript:void(0);" class="btn btn-success mb-2 me-0">
                                    <font-awesome-icon icon="eye" />
                                    View
                                </a>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import apiRepository from "@/services/ApiRepository";
    import {toast} from 'vue3-toastify'

    export default {
        components: {
            draggable
        },
        data() {
            return {
                isVisible: false,
                getDataWasiyyah: [],
                editModeKey: null,
                editFormData: {
                    title: '',
                    content: '',
                    visible: 'Y',
                    orderSeq: '',
                    requestKey: ''
                },
                visibleModeKey: null,
                // items: [],
                visibleFormData: {
                    title: '',
                    content: '',
                    visible: 'N',
                    orderSeq: '',
                    requestKey: ''
                },
                wasiyyahEntryData: {
                    title: '',
                    content: '',
                    visible: 'Y',
                    orderSeq: ''
                },
                drag: false,
                items: [
                    {id: 1, name: "Abby", sport: "basketball"},
                    {id: 2, name: "Brooke", sport: "soccer"},
                    {id: 3, name: "Courtenay", sport: "volleyball"},
                    {id: 4, name: "David", sport: "rugby"},
                ],
            };
        },
        created() {
            this.getWasiyyahData()
        },
        watch: {
            //
        },
        computed: {
            formattedItems() {
                console.timeEnd(JSON.stringify(this.items, null, 2))
                const str = JSON.stringify(this.items, null, 2);
                return str;
            },
            letterCount() {
                return this.wasiyyahEntryData.content.trim().replace(/\s+/g, '').length;
            },
            textColor() {
                return this.letterCount < 100 ? "text-danger" : "text-success";
            }

        },
        methods: {
            updateOrder() {
                // Clear the updatedOrder array
                this.updatedOrder = [];

                // Push the new order details to the array
                this.getDataWasiyyah.forEach((element, index) => {
                    this.updatedOrder.push({
                        requestKey: element.requestKey,
                        order: index + 1, // Index + 1 to make it 1-based
                    });


                });
                console.log("Updated Order:", this.updatedOrder);
                apiRepository.changeWasiyyahOrder(this.updatedOrder).then((res) => {
                    if (res) {
                        console.log(res)
                        this.getWasiyyahData();
                    }
                })
            },

            // Log the updated order or send it to an API
            toggleDivVisibility() {
                this.isVisible = !this.isVisible; // Flip the visibility
            },
            getWasiyyahData() {
                apiRepository.getWasiyyah().then((response) => {
                    if (response || response.data) {
                        this.getDataWasiyyah = response.data;
                        let latestOrderSeq = Math.max(...response.data.map(item => item.orderSeq));
                        this.wasiyyahEntryData.orderSeq = latestOrderSeq + 1;
                    } else {
                        this.wasiyyahEntryData.orderSeq = 1
                        toast.error("Invalid Request!")
                    }
                })
            },
            enterEditMode(item) {
                this.editModeKey = item.requestKey;
                this.editFormData = {...item};
            },
            contentVisible(item) {
                const previousVisibility = item.visible;
                item.visible = item.visible === 'Y' ? 'N' : 'Y';
                apiRepository.saveWasiyyah(item).then((response) => {
                    if (response && response.data) {
                        console.log(response.data);
                    } else {
                        // If API fails, revert visibility change
                        item.visible = previousVisibility;
                        console.error('Failed to update visibility.');
                    }
                }).catch((error) => {
                    // If API fails, revert visibility change
                    item.visible = previousVisibility;
                    console.error("Error updating data:", error);
                });
            },

            submitEdit() {
                apiRepository.saveWasiyyah(this.editFormData).then((response) => {
                    if (response || response.data) {
                        toast.success(response.data || "RECORD INSERTED SUCCESSFULLY!!")
                        this.getWasiyyahData();
                        this.cancelEdit();
                    } else {
                        toast.error(response.data || "ENTER YOUR VALID DATA.")
                    }
                }).catch((error) => {
                    console.error("Error updating data:", error);
                });
            },

            cancelEdit() {
                this.editModeKey = null;
                this.editFormData = {}
            },
            onSubmit() {
                apiRepository.saveWasiyyah(this.wasiyyahEntryData).then((response) => {
                    if (response) {
                        toast.success(response.data || "RECORD INSERTED SUCCESSFULLY!!")
                        this.onReset()
                    } else {
                        toast.error(response.data)
                    }
                }).catch(error => {
                    toast.error(error.response?.data?.message || "Mandatory fields cannot be null!");
                });
            },
            onReset() {
                this.visibleFormData = {
                    content: '',
                    orderSeq: '',
                    requestKey: '',
                    title: '',
                    visible: 'N',
                }
                this.wasiyyahEntryData = {
                    contentTitle: '',
                    content: '',
                    visibleYn: '',
                    order: ''
                }
                this.editFormData = {
                    contentTitle: '',
                    content: '',
                    visibleYn: '',
                    order: ''
                }
            }

        }
    };
</script>


<style>


    .section-item {
        margin: 10px 0;
        padding: 15px;
        background: white;
        border-radius: 5px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .hr-cls {
        /*border: 1px solid #077747;*/
        color: #077747;
    }

    .hr-cls1 {
        color: #077747;
    }

/*    .para {
        margin-left: 160px;
    }*/

    wasiyyah-card {
        transition: opacity 0.5s ease-in-out;
    }

    .draggable-container {
        cursor: default;
    }

    .draggable-container .draggable-item {
        cursor: move; /* Change cursor to 'move' when hovering over items */
    }

    .draggable-container .draggable-item:active {
        cursor: grabbing; /* Change to 'grabbing' when dragging */
    }

    .text-danger {
        color: red;
    }

    .text-success {
        color: green;
    }
</style>